// extracted by mini-css-extract-plugin
export default {"header":"_-_-record-it-components-src-misc-ExpandableContainerWithHeader-__header","content":"_-_-record-it-components-src-misc-ExpandableContainerWithHeader-__content"};